// One type scale for the settings page.
//
// Before this the page mixed h4, h5, h6, body1 and caption for things that are
// all the same kind of label, so each tab looked like it came from a different
// screen. The integrations list set the scale everything now follows:
//
//   card title   h4 + .header-text   (unchanged — the blue bar)
//   row label    body1 @ 600
//   secondary    caption, textSecondary
//
// Exported as props rather than a component so it can be spread onto the
// Typography already in place, without rewriting the markup around it.
export const ROW_LABEL = {
  variant: 'body1',
  style: { fontWeight: 600 },
};

// A label over a group of fields inside a card (e.g. "QConnect Credentials").
// These were variant="h4" — 2.125rem, bigger than some card titles — because
// .admin__product-settings sets colour and margin but no font size.
export const GROUP_HEADING = {
  variant: 'subtitle1',
  style: { fontWeight: 700 },
};

export const ROW_SECONDARY = {
  variant: 'caption',
  color: 'textSecondary',
};
